import { slug } from "github-slugger";
import Category from "./Category";

const Categories = ({ categories, currentSlug }) => {
  return (
    <div className="sxl:px-20 text-dark dark:text-light border-dark dark:border-light mx-5 mt-10 flex flex-wrap items-start border-b-2 border-t-2 border-solid px-0 py-4 font-medium md:mx-10 md:px-10">
      {categories.map((cat) => (
        <Category
          key={cat}
          link={`/blog-categories/${slug(cat)}`}
          name={cat}
          active={currentSlug === slug(cat)}
        />
      ))}
    </div>
  );
};

export default Categories;
